var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59763 30.0765C5.26963 30.0757 4.19318 28.9992 4.19141 27.6712V4.32543C4.19318 2.99921 5.26785 1.92365 6.59496 1.92188H25.8207C27.147 1.92365 28.2225 2.99832 28.2243 4.32543V27.6712C28.2243 28.9983 27.1487 30.0739 25.8216 30.0748C25.3016 30.0748 24.7959 29.9059 24.3799 29.5939L16.4145 23.6205C16.2927 23.529 16.1256 23.529 16.0038 23.6205L8.03852 29.5948C7.62341 29.9077 7.11852 30.0765 6.59852 30.0774L6.59763 30.0765ZM6.59496 3.98232C6.40563 3.98232 6.25185 4.1361 6.25185 4.32543V27.6712C6.25185 27.8605 6.40474 28.0143 6.59407 28.0143C6.66874 28.0143 6.74074 27.9903 6.8003 27.945L14.7647 21.9717C15.6207 21.3343 16.7941 21.3343 17.6501 21.9717L25.6145 27.9441C25.7656 28.0579 25.9799 28.0277 26.0936 27.8774C26.139 27.8179 26.163 27.745 26.163 27.6703V4.32543C26.163 4.1361 26.0092 3.98232 25.8199 3.98232H6.59496Z",
    fill: "#21438E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel);
export default __webpack_public_path__ + "static/media/label.b34a106181cb77f07a8e9e7776badd0b.svg";
export { ForwardRef as ReactComponent };